exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".gray-500[data-v-3ed5b976] {\n  color: #9a9a9a;\n}\n.danger-light[data-v-3ed5b976] {\n  color: #ff001da3;\n}\n", ""]);

// exports
